import { supabase } from '../../shared/supabase/supabaseClient';
import { invalidateStorefrontMpStatus } from '../../settings/infra/storefrontStatusCache';

export type MpPosConfigRow = {
  branch_id: string;
  external_pos_id: string;
  mode: 'production';
};

export type MpIntegrationStatus = {
  oauth_connected: boolean;
  pos_configured: boolean;
};

export const getMpIntegrationStatus = async (branchId: string): Promise<MpIntegrationStatus> => {
  const { data, error } = await supabase.rpc('mp_integration_status_get', {
    p_branch_id: branchId,
  });
  if (error) throw new Error(error.message || 'Error al leer estado de Mercado Pago');
  const row = (data ?? {}) as { oauth_connected?: boolean; pos_configured?: boolean };
  return {
    oauth_connected: row.oauth_connected === true,
    pos_configured: row.pos_configured === true,
  };
};

export const getMpPosConfig = async (branchId: string): Promise<MpPosConfigRow | null> => {
  const { data, error } = await supabase.rpc('mp_pos_config_get', {
    p_branch_id: branchId,
  });
  if (error) throw new Error(error.message || 'No se pudo leer la caja QR');
  return (data as MpPosConfigRow | null) ?? null;
};

export const saveMpPosConfig = async (branchId: string, externalPosId: string): Promise<MpPosConfigRow> => {
  const { data, error } = await supabase.rpc('mp_pos_config_upsert', {
    p_branch_id: branchId,
    p_external_pos_id: externalPosId.trim(),
    p_mode: 'production',
  });
  if (error) throw new Error(error.message || 'No se pudo guardar la caja QR');
  invalidateStorefrontMpStatus(branchId);
  return data as MpPosConfigRow;
};
